import { formatCurrency } from "utils/utils";
import { ButtonLink } from "./ButtonLink";
import Loader from "components/Loader";
import { useEffect, useState } from "react";
import ShowMoreContent from "./ShowMoreContent";

export function BasketContentFavoriteItem(props) {
    const { item, actions } = props;
    const [loading, setloading] = useState(false);

    useEffect(() => {
        console.log('item', item)
    }, [item])

    return (
        <Loader isLoading={loading}>
            <div className="row gap-24 pt-32" id="product-row-@item.Id">
                <div className="col-auto">
                    <img src={item.imageUrl} className="w-h-164" />
                </div>
                <div className="col">

                    <div className="row mb-8">
                        <div className="col">
                            <a className="subtitle1 default-text" href={item.fabricUrl} title={item.title}>{item.title}</a>
                        </div>
                        <div className="col-auto align-top mt-1">
                            <span className="curtains-icon curtains-icon-octicon_trash-24 size-24 gray pointer"
                                onClick={async () => {
                                    if (confirm('Are you sure want to remove this product?')) {
                                        setloading(!loading);          
                                        try {
                                            await actions.onDeleteFavoriteItem(item);
                                        }
                                        finally {
                                            setloading(false);
                                        }
                                    }
                                }}></span>
                        </div>
                    </div>

                    <div className="body-text3 active-group sm-text-14">
                        <div>
                            <span className="gray">Collection: </span>
                            <a href={item.collectionUrl} className="underline">
                                {item.collectionName}
                            </a>
                        </div>
                        { item.showMore && item.showMore !== '' && <ShowMoreContent content={item.showMore} /> }
                        <div>
                            <span className="gray">Colour:</span> {item.colour || 'None'}
                        </div>
                        <div>
                            <span className="gray">Qty: {item.quantityUnitPrice}</span>
                        </div>
                    </div>

                    <div className="body-text4 mt-8">{formatCurrency(item.price)}</div>

                    <div className="sm-no">                            
                        <div className="d-flex gap-32 mt-16 body-text3 color-bg2">
                            <ButtonLink name="Add to Bag"
                                onClick={async () => {
                                    setloading(!loading);          
                                    try {
                                        await actions.onAddToBag(item);
                                    }
                                    finally {
                                        setloading(false);
                                    }
                                }
                            }/>
                            {
                                item.productType === 100 ? <></> : 
                                <div className="align-center">                            
                                    <span className="underline pointer show-btn hide-btn"
                                    onClick={() => {
                                        setloading(!loading);
                                        actions.editFabricItem(item);
                                    }}
                                    data-show="#item-edit-@index"
                                    data-hide="#basket-main-content" data-no-activate="1">Edit</span>
                                </div>
                            }
                        </div>
                    </div>

                </div>
            </div>
            <div className="sm-yes">                    
                <div className="d-flex gap-32 mt-16 body-text3 color-bg2">
                    <div className="width-220">                        
                        <ButtonLink name="Add to Bag"
                            onClick={async () => {
                                setloading(!loading);          
                                try {
                                    await actions.onAddToBag(item);
                                }
                                finally {
                                    setloading(false);
                                }
                            }
                        }/>
                    </div>
                    {
                        item.productType === 100 ? <></> : 
                        <div className="align-center">                            
                            <span className="underline pointer show-btn hide-btn"
                            onClick={() => {
                                setloading(!loading);
                                actions.editFabricItem(item);
                            }}
                            data-show="#item-edit-@index"
                            data-hide="#basket-main-content" data-no-activate="1">Edit</span>
                        </div>
                    }
                </div>
            </div>
            <div className="dashed-line mt-32"></div>
        </Loader>
    );
}
